export type JourneyCategory = 'work' | 'relation' | 'project';

export interface ExampleStepView {
  title: string;
  description?: string | null;
  sort_order?: number;
  element_category?: JourneyCategory | string | null;
  target_stage_index?: number;
  assistant_prompt_template?: string | null;
}

export interface ExampleListItem {
  id: string;
  title: string;
  description: string | null;
  is_published?: boolean;
  sort_order?: number;
  step_count?: number;
  created_at?: number;
  steps?: ExampleStepView[];
}

export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function sphereLabel(sphere: string | null | undefined): string {
  if (sphere === 'work') return 'Работа';
  if (sphere === 'relation') return 'Отношения';
  if (sphere === 'project') return 'Проекты';
  return sphere || '—';
}

export function sphereBadgeClass(sphere: string | null | undefined): string {
  if (sphere === 'work') return 'rm-badge-sphere-work';
  if (sphere === 'relation') return 'rm-badge-sphere-relation';
  if (sphere === 'project') return 'rm-badge-sphere-project';
  return 'rm-badge-sphere-default';
}

export function primarySphere(map: ExampleListItem): string | null {
  const steps = map.steps || [];
  if (!steps.length) return null;
  const counts = new Map<string, number>();
  for (const step of steps) {
    const key = step.element_category || '';
    if (!key) continue;
    counts.set(key, (counts.get(key) || 0) + 1);
  }
  let best: string | null = null;
  let bestCount = 0;
  counts.forEach((count, key) => {
    if (count > bestCount) {
      best = key;
      bestCount = count;
    }
  });
  return best;
}

export function estimateDuration(stepCount: number): string {
  if (stepCount >= 4) return '10–15 мин';
  if (stepCount >= 2) return '7–10 мин';
  return '5–7 мин';
}

export function stepCountLabel(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return `${count} этап`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${count} этапа`;
  return `${count} этапов`;
}

export function isStarterMap(map: ExampleListItem, index: number): boolean {
  if (index === 0) return true;
  const steps = map.step_count ?? map.steps?.length ?? 0;
  return steps >= 4;
}

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export function isRecentMap(map: ExampleListItem): boolean {
  if (!map.created_at) return false;
  return Date.now() - map.created_at < THIRTY_DAYS_MS;
}

export function shortStepTitle(title: string, maxLen = 28): string {
  const t = title.trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, maxLen - 1)}…`;
}
